import { styled } from '@mui/material/styles';
import BottomNavigation from '@mui/material/BottomNavigation';
import BottomNavigationAction from '@mui/material/BottomNavigationAction';
import ButtonGroup from '@mui/material/ButtonGroup';
import Button from '@mui/material/Button';

export const StyledBottomNavigation = styled(BottomNavigation)<{ width: string }>(({ width }) => ({
    width: width,
    backgroundColor: '#E1E4E7',
    borderRadius: '4px',
    overflow: 'hidden',
    display: 'flex',
    height: '40px',
}));

export const StyledBottomNavigationAction = styled(BottomNavigationAction, {
    shouldForwardProp: (prop) =>
        !['custommaxwidth', 'data-isactive', 'data-isleft', 'data-isright'].includes(prop.toString()),
})<{
    custommaxwidth?: string;
    'data-isactive'?: boolean;
    'data-isleft'?: boolean;
    'data-isright'?: boolean;
}>(({
    custommaxwidth,
    'data-isactive': isactive,
    'data-isleft': isleft,
    'data-isright': isright
}) => ({
    width: '200px',
    maxWidth: custommaxwidth || '250px',
    height: '100%',
    backgroundColor: isactive ? '#1273EB' : 'transparent',
    color: isactive ? 'white' : 'inherit',
    borderTopLeftRadius: isleft && isactive ? '4px' : 0,
    borderBottomLeftRadius: isleft && isactive ? '4px' : 0,
    borderTopRightRadius: isright && isactive ? '4px' : 0,
    borderBottomRightRadius: isright && isactive ? '4px' : 0,
    padding: '16px',
    '& .MuiBottomNavigationAction-label': {
        fontSize: '1rem',
    },
    '&.Mui-selected': {
        backgroundColor: '#0054E6',
        color: 'white',
    },
}));

export const StyledBottomGroup = styled(ButtonGroup)<{ width: string }>(({ width }) => ({
    width: width,
    backgroundColor: '#E1E4E7',
    borderRadius: '30px',
    overflow: 'hidden',
    display: 'flex',
    height: '40px',
    border: 'none'
}));
export const StyledBottom = styled(Button, {
    shouldForwardProp: (prop) =>
        !['customwidth', 'custommaxwidth', 'data-isleft', 'data-isright']
            .includes(prop.toString()),
})<{
    customwidth: string;
    custommaxwidth: string;
    'data-isleft'?: string;
    'data-isright'?: string;
}>(({
    customwidth,
    custommaxwidth,
    'data-isleft': isleft,
    'data-isright': isright
}) => ({
    width: customwidth,
    maxWidth: custommaxwidth,
    height: '100%',
    backgroundColor:
        isleft === 'true' ? '#E1E4E7' :
            isright === 'true' ? '#1273EB' :
                '#E1E4E7',
    color: (isleft === 'true') ? 'inherit' : 'white',
    borderTopLeftRadius: isleft ? '30px' : 0,
    borderBottomLeftRadius: isleft ? '30px' : 0,
    borderTopRightRadius: isright ? '30px' : 0,
    borderBottomRightRadius: isright ? '30px' : 0,
    border: 'none',
    padding: '16px',
    '& .MuiBottomNavigationAction-label': {
        fontSize: '1rem',
    },
    '&.Mui-selected': {
        backgroundColor: '#1273EB',
        color: 'white',
    },
}));